import React, { useCallback, useEffect, useState } from 'react';
import { AppButton, Block, FlexBox, IconCheckCircleClientReview, TextCommon, useHttpCommand } from '@esg/ui';
import { Card } from 'antd';
import { env } from '@/configs';
import { ClientReviewCreateResponse, updateClientReview, UpdateClientReviewRequest } from '@esg/business-client-review';
import { ReviewFormValues } from './ReviewForm';
import { GoogleRatingStatus } from '@esg/shared';
import { GetDetailSaleBasicResponse } from '@esg/business-pos';
import { SocialType } from '../../../../../../packages/business/organization/api/branch/getDetailBranch';
import { translateCodes } from '@/locales';
import { useTranslation } from 'react-i18next';

interface SuccessReviewToGoogleMapProps {
  defaultValues?: ClientReviewCreateResponse;
  handleShowSuccess: (value: ClientReviewCreateResponse) => void;
  headerRequest?: Record<string, string>;
  saleDetail?: GetDetailSaleBasicResponse | null | undefined;
}

export function SuccessReviewToGoogleMap(props: SuccessReviewToGoogleMapProps) {
  const { t } = useTranslation();
  const [placeId, setPlaceId] = useState<string>("");
  const { mutateAsync: updateReview } = useHttpCommand(updateClientReview);
  const branchAddress = props.saleDetail?.branch?.socialLinks?.find(o => o.type === SocialType.GoogleMap)?.value;
  const handleReviewClick = async () => {
    await onSubmit(props.defaultValues!);
    const reviewUrl = `https://search.google.com/local/writereview?placeid=${placeId}`;
    window.open(reviewUrl, '_blank');
  };

  const onSubmit = useCallback(
    async (values: ReviewFormValues) => {
      await updateReview(
        {
          header: props.headerRequest,
          pathData: {
            id: props.defaultValues?.id,
            reviewToken: props.saleDetail?.id,
          },
          body: {
            ...values as UpdateClientReviewRequest['body'],
            googleRatingStatus: GoogleRatingStatus.Accepted
          },

        },
        { onSuccess: () => { } }
      );
    },
    [updateReview]
  );

  function extractAddressFromGoogleMapsUrl(url: string): string | null {
    const match = url.match(/\/place\/([^\/]+)\//);
    if (!match) return null;
    const rawAddress = match[1];
    const decodedAddress = decodeURIComponent(rawAddress.replace(/\+/g, ' '));

    return decodedAddress;
  }


  async function fetchGoogleMapData(address: string): Promise<any> {
    try {
      const addressResult = extractAddressFromGoogleMapsUrl(address);
      const key = env.apiKeyGoogleMap;
      const url = `${env.urlGoogleMap}?address=${encodeURIComponent(addressResult ?? '')}&key=${key}`;
      const response = await fetch(url);
      const data = await response.json();
      return data;
    } catch (error) {
      return null;
    }
  }

  useEffect(() => {
    async function fetchData() {
      const data = await fetchGoogleMapData(branchAddress ?? 'Công Ty Cổ Phần CTnet');
      if (data) {
        setPlaceId(data.results[0].place_id);
      }
    }
    fetchData();
  }, []);

  return (
    <Block width={500}>
      <Card >
        <FlexBox direction={'column'} gap={15} alignItems='center'>
          <IconCheckCircleClientReview />
          <FlexBox direction='column' alignItems='center'>
            <TextCommon fontWeight={700} fontSize={24} translateCode={translateCodes.WE_LOVE_FEEDBACK} />
            <TextCommon textAlign='center' fontSize={16} translateCode={translateCodes.SHARE_EXPERIENCE_GOOGLE} />
          </FlexBox>
          <AppButton onClick={handleReviewClick} type="primary" width='60%'>
            {t(translateCodes.CLICK_TO_REVIEW)}
          </AppButton>
        </FlexBox>
      </Card>
    </Block>
  );
}
